import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button, TextField, Grid } from "@material-ui/core";
import "./login.css";
import { API_URL } from "../Config";
import Image from "../assets/images/email.svg";
import forgetotp from "../assets/images/forgetotp.png";
import SnackBarComponent from "../SnackBar/SnackBar";
// import Cookies from "js-cookie";
let crypto = require("crypto");
class VerifyOTP extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Otp: "",
      username: !this.props.location.state
        ? ""
        : !this.props.location.state.username
        ? ""
        : this.props.location.state.username,
      time: {},
      seconds: 60,
      error: {},
      emailSection: "",
      email: !this.props.location.state
        ? ""
        : !this.props.location.state.email
        ? ""
        : this.props.location.state.email,
      verificationCodeTo: !this.props.location.state
        ? ""
        : !this.props.location.state.verificationCodeTo
        ? ""
        : this.props.location.state.verificationCodeTo,
      type: !this.props.location.state
        ? ""
        : !this.props.location.state.type
        ? ""
        : this.props.location.state.type,
      message: this.props.location.state
        ? this.props.location.state.message
        : "",
      open: false,
      severity: "",
      alertmsg: "",
      connectionError: "",
      disabled: false,
    };
  }
  componentDidMount() {
    this.timer = 0;
    let timeLeftVar = this.secondsToTime(this.state.seconds);
    this.secondsToTime(this.state.seconds);
    this.setState({ time: timeLeftVar });
    this.startTimer();
    if (this.state.type === "/forgotpassword") {
    }
  }
  UNSAFE_componentWillMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    }
  }
  secondsToTime = (secs) => {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);
    minutes = ("0" + minutes).slice(-2);
    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);
    seconds = ("0" + seconds).slice(-2);

    let obj = {
      h: hours,
      m: minutes,
      s: seconds,
    };
    return obj;
  };
  startTimer = () => {
    if (this.timer === 0 && this.state.seconds > 0) {
      this.timer = setInterval(this.countDown, 1000);
    }
  };

  countDown = () => {
    // Remove one second, set state so a re-render happens.
    let seconds = this.state.seconds - 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });

    // Check if we're at zero.
    if (seconds === 0) {
      clearInterval(this.timer);
    }
  };
  handleTextFieldChange = (e) => {
    let {
      target: { value, name },
    } = e;
    let { error } = this.state;
    if (name !== "") {
      delete error[name];
    }
    this.setState({ [name]: value });
  };
  onKeyDownHandler = (e) => {
    if (e.keyCode === 13) {
      this.sendOtp(e);
    }
  };
  Validation = () => {
    let error = {};
    let { Otp } = this.state;
    if (Otp === "") {
      error["Otp"] = "Please enter OTP";
    }
    this.setState({ error });
    if (Object.keys(error).length === 0) {
      return true;
    } else {
      return false;
    }
  };
  handleClose = () => {
    this.setState((prevState) => {
      return {
        open: !prevState.open,
      };
    });
  };
  getOtp = () => {
    if (this.state.type === "/forgotpassword") {
      fetch(
        `${API_URL}/api/Userdata/two-factor-login?email=${this.state.email}&verificationCodeTo=${this.state.verificationCodeTo}`,
        {
          method: "POST",
          mode: "cors",
          body: JSON.stringify({
            // query: Query,
            // variables: Variables,
          }),
          headers: {
            "Content-type": "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.data) {
            this.setState({
              open: true,
              severity: res.data.status,
              alertmsg: res.data.message,
            });
          } else {
            this.setState({
              open: true,
              severity: "error",
              alertmsg: res.message,
              timer: 3000,
            });
          }
        })
        .catch((e) => {
          this.setState({
            open: true,
            severity: "error",
            alertmsg: e.message,
            timer: 3000,
          });
        });
    } else {
      fetch(
        `${API_URL}/api/Userdata/generateOTP?refreshOtpToken=${localStorage.getItem(
          "refreshtoken"
        )}&verificationCodeTo=${this.state.verificationCodeTo}`,
        {
          method: "POST",
          mode: "cors",
          body: JSON.stringify({
            // query: Query,
            // variables: Variables,
          }),
          headers: {
            "Content-type": "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then((res) => {
          this.setState({
            open: true,
            severity: res.data.status,
            alertmsg: res.data.message,
          });
        })
        .catch((e) => {
          this.setState({
            open: true,
            severity: "error",
            alertmsg: e.message,
            timer: 3000,
          });
        });
    }
  };
  Resend = () => {
    if (this.state.seconds === 0) {
      let seconds = 60;
      this.setState({ seconds: 60 }, () => this.startTimer());
      this.timer = 0;
      let timeLeftVar = this.secondsToTime(seconds);
      this.secondsToTime(this.state.seconds);
      this.startTimer();
      this.setState({ time: timeLeftVar });
      this.getOtp();
    }
  };

  sendOtp = (e) => {
    e.preventDefault();
    let check = this.Validation();
    if (!check) {
      return;
    } else {
      this.setState({ disabled: true });
      if (this.state.type === "/forgotpassword") {
        fetch(
          `${API_URL}/api/Userdata/verifyOtp2fa?otp=${
            this.state.Otp
          }&email=${localStorage.getItem("email")}`,
          {
            method: "POST",
            mode: "cors",
            body: JSON.stringify({
              // query: Query,
              // variables: Variables,
            }),
            headers: {
              "Content-type": "application/json",
            },
          }
        )
          .then((res) => res.json())
          .then((res) => {
            this.setState({ disabled: false });
            if (res.status === "success") {
              localStorage.setItem("refreshtoken", res.data.accessToken);
              this.setState({
                open: true,
                alertmsg: res.messsage,
                severity: res.status,
              });
              this.props.history.push({
                pathname: "/changepassword",
                state: { check: "changepassword" },
              });
            } else {
              if (res.code === "REACHED_MAX_OTP_ATTEMPTS") {
                setTimeout(() => {
                  this.props.history.push("/");
                }, 2000);
              }
              this.setState({
                connectionError: res.message,
              });
            }
          })
          .catch((e) => {
            this.setState({
              disabled: false,
              connectionError: e.toString().substring(11, e.length),
            });
          });
      } else {
        fetch(
          `${API_URL}/api/Userdata/otpVerification?otp=${
            this.state.Otp
          }&refreshToken=${localStorage.getItem("refreshtoken")}`,
          {
            method: "POST",
            mode: "cors",
            body: JSON.stringify({
              // query: Query,
              // variables: Variables,
            }),
            headers: {
              "Content-type": "application/json",
            },
          }
        )
          .then((res) => res.json())
          .then((res) => {
            this.setState({ disabled: false });
            if (res.status === "success") {
              let mykey1 = crypto.createCipher("aes-128-cbc", "mypassword");
              let mystr1 = mykey1.update(res.data.role, "utf8", "hex");
              mystr1 += mykey1.final("hex");
              localStorage.setItem("token", res.data.token);
              localStorage.setItem("email", res.data.email);
              localStorage.setItem("id", res.data.id);
              localStorage.setItem("role", mystr1);
              localStorage.setItem(
                "name",
                `${res.data.firstname}` +
                  `${res.data.lastname == null ? "" : " " + res.data.lastname}`
              );

              localStorage.setItem(
                "userInitials",
                `${res.data.firstname.substring(0, 1)}` +
                  `${
                    res.data.lastname == null
                      ? ""
                      : res.data.lastname.substring(0, 1)
                  }`
              );
              localStorage.removeItem("refreshtoken")
              window.location = "/sites";
            } else {
              if (res.code === "REACHED_MAX_OTP_ATTEMPTS") {
                setTimeout(() => {
                  this.props.history.push("/");
                }, 2000);
              }
              this.setState({
                connectionError: res.message,
              });
            }
          })
          .catch((e) => {
            console.log(e);
            this.setState({
              disabled: false,
              connectionError: e.toString().substring(11, e.length),
            });
          });
      }
    }
  };
  BacktoLogin = () => {
    localStorage.clear();
  };
  render() {
    return (
      <div className="verifyOtpSection">
        {this.state.type === "/forgotpassword" ? "" : <h4>Verify OTP</h4>}
        <div className="verifyImage">
          <img
            src={this.state.type === "/forgotpassword" ? forgetotp : Image}
            alt="uptake Medical"
          ></img>
        </div>
        {this.state.type === "/forgotpassword" ? (
          <h4 className="verifyOtpHeader">ENTER OTP</h4>
        ) : (
          ""
        )}

        <p className="sendotpStatement">{this.state.message}</p>

        <TextField
          variant="standard"
          label="Enter OTP"
          name="Otp"
          value={this.state.Otp}
          autoFocus
          onChange={this.handleTextFieldChange}
          helperText={this.state.error.Otp}
          type="password"
          onKeyDown={this.onKeyDownHandler}
        />
        <ul className="otpPart">
          <li>
            {" "}
            {this.state.seconds > 0 ? (
              <p>
                Resend OTP in {`${this.state.time.m} : ${this.state.time.s}`}
              </p>
            ) : (
              ""
            )}
          </li>
          {this.state.seconds === 0 ? (
            <li>
              Didn't receive? <span onClick={this.Resend}>Resend OTP</span>
            </li>
          ) : (
            ""
          )}
        </ul>
        {this.state.connectionError ? (
          <div className="connectionOtp">
            <p>{this.state.connectionError}</p>
          </div>
        ) : (
          ""
        )}
        <Button
          fullWidth
          variant="contained"
          color="primary"
          type="submit"
          className="loginbtn"
          onClick={this.sendOtp}
          disabled={this.state.disabled}
        >
          {this.state.type === "/forgotpassword" ? "Confirm" : "Verify"}
        </Button>
        <Grid container className="createAccount">
          <Grid item xs>
            <Link to="/" onClick={this.BacktoLogin}>
              Back To Login Page
            </Link>
          </Grid>
        </Grid>
        {this.state.open ? (
          <SnackBarComponent
            severity={this.state.severity}
            open={this.state.open}
            alertmsg={this.state.alertmsg}
            handleClose={this.handleClose}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}
export default VerifyOTP;
